// HomePage.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles/HomePage.css';
import useScrollReveal from './hooks/useScrollReveal';
import HeroSlider from './components/HeroSlider';
// Import icons from lucide-react
import { ChevronRight, Sparkles, Shirt, Crown, User, Mail, Phone, MapPin, Instagram, Facebook, Twitter, Clock, Wand2, Loader2, Star, Menu, Sun, Moon,Navigation } from 'lucide-react'; // Added Sun/Moon for theme toggle
import { FaWhatsapp } from "react-icons/fa"; 
// Import Firebase
import { db } from './firebaseConfig';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import logo1 from "../src/assets/DOR white.png";
import logo2 from "../src/assets/DOR black.png"
// Import Helmet for SEO meta tags
import { Helmet } from 'react-helmet-async';
import CustomerReviewUpload from "./components/CustomerReviewUpload";
import CustomerReviewsSection from "./components/CustomerReviewsSection";
import Header from "./components/Header";
import CollaborationSection from "./components/CollaborationSection";
import EarnWithUsModal from "./components/EarnWithUsModal";
import ReviewsSection from './components/ReviewsSection';
const WhatsAppIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    aria-hidden="true"
  >
    <path
      fill="#25D366"   // ✅ OFFICIAL WHATSAPP GREEN
      d="M19.11 17.33c-.27-.14-1.57-.77-1.81-.85-.24-.09-.42-.14-.6.14-.17.27-.69.85-.84 1.03-.15.17-.31.19-.58.07-.27-.14-1.13-.42-2.16-1.33-.8-.7-1.35-1.56-1.51-1.83-.16-.27-.02-.42.12-.56.13-.13.27-.31.4-.47.13-.16.17-.27.27-.45.09-.18.05-.33-.02-.47-.07-.14-.6-1.44-.82-1.97-.22-.53-.44-.46-.6-.46-.16 0-.33-.02-.51-.02-.18 0-.47.07-.72.33-.25.27-.95.93-.95 2.27 0 1.33.97 2.63 1.11 2.81.14.18 1.91 2.93 4.63 4.1 2.72 1.17 2.72.78 3.21.75.49-.02 1.57-.64 1.79-1.27.22-.64.22-1.19.16-1.31-.05-.13-.24-.2-.51-.33zM16 3C9.37 3 4 8.37 4 15c0 2.11.55 4.09 1.51 5.8L4 29l8.36-1.48C13.99 28.45 14.98 28.6 16 28.6c6.63 0 12-5.37 12-12S22.63 3 16 3zm0 22.8c-.96 0-1.9-.16-2.78-.48l-.2-.07-4.87.86.9-4.75-.1-.2A9.83 9.83 0 0 1 6.8 15c0-5.07 4.13-9.2 9.2-9.2s9.2 4.13 9.2 9.2-4.13 9.2-9.2 9.2z"
    />
  </svg>
);


function HomePage() {
  const [menCategories, setMenCategories] = useState([]);
  const [womenCategories, setWomenCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [categoryError, setCategoryError] = useState('');
  const [allProducts, setAllProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [productFetchError, setProductFetchError] = useState('');

  // Store Locations Data - Now fetched dynamically
  const [storeLocations, setStoreLocations] = useState([]);
  const [loadingStores, setLoadingStores] = useState(true);
  const [storeError, setStoreError] = useState('');
const [showEarnModal, setShowEarnModal] = useState(false); // <--- ADD THIS
  // NEW THEME STATE & TOGGLE FUNCTION
const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const toggleTheme = () => {
    setTheme(currentTheme => {
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      localStorage.setItem('theme', newTheme); // Save the new theme choice
      return newTheme;
    });
  };
  // END NEW THEME STATE

  // NEW STATE: State for modal visibility
  const [showStoreModal, setShowStoreModal] = useState(() => {
  return !localStorage.getItem('selectedStore');
});
  // NEW STATE for scroll effect
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation(); // Get the current location object


  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        // Scroll smoothly to the element
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // After scrolling, remove the hash from the URL
          // Use replaceState to change the URL without adding a new entry to the browser history
          window.history.replaceState({}, document.title, window.location.pathname);
        }, 100); // Small delay to allow scroll to initiate
      }
    }
  }, [location]); // Re-run effect when the location object (specifically the hash) changes
  // Re-run effect when the location object (specifically the hash) changes
  useEffect(() => {
    // Use setTimeout with a small delay to override browser's scroll restoration
    setTimeout(() => {
      window.scrollTo(0, 0); // Scroll to the very top (x=0, y=0)
    }, 0); // A 0ms delay moves it to the end of the current JavaScript execution queue
  }, []);
  useEffect(() => {
  const handleOpenStoreModal = () => {
    setShowStoreModal(true);
  };

  window.addEventListener("openStoreModal", handleOpenStoreModal);

  return () => {
    window.removeEventListener("openStoreModal", handleOpenStoreModal);
  };
}, []);
  // Effect for scroll to add/remove 'scrolled' class
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) { // Adjust this value as needed
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Data for Testimonials (can also be fetched from Firebase)
  const stores = [
  {
    id: "pune-wakad",
    name: "DOR — Pune - PCMC",
    address: "Mount Vert Society Square, Hinjawadi - Aundh Rd, next to Yug Honda, Kaspate Wasti, Pimpri-Chinchwad, Maharashtra 411057",
    phoneDisplay: "+918698797007",
    phone: "+918698797007",
    email: "contact@dordressonrent.com",
    instagram: "https://www.instagram.com/dor_designer?igsh=MWp4dmgyMWdibnMxcw==",
    facebook: "https://www.facebook.com/share/1D8F1q6RRZ/?mibextid=wwXIfr",
    whatsapp: "https://wa.me/918698797007?text=Hi%20DOR%20Wakad%2C%20I%27d%20like%20to%20rent%20an%20outfit",
    mapsDest: "https://share.google/jfvJEM6NjSnFAktzG",
  },
 
  {
    id: "nagpur-civillines",
    name: "DOR — Nagpur",
    address: "BSGN SOCIETY, 7, above ANNA IDLI, Shyam Nagar, Manish Nagar, Somalwada, Nagpur, Maharashtra 440037",
    phoneDisplay: "+918698797007",
    phone: "+918698797007",
    email: "contact@dordressonrent.com",
    instagram: "https://www.instagram.com/dor_designer?igsh=MWp4dmgyMWdibnMxcw==",
    facebook: "https://www.facebook.com/share/1D8F1q6RRZ/?mibextid=wwXIfr",
    whatsapp: "https://wa.me/918698797007?text=Hi%20DOR%20Nagpur%2C%20need%20help%20with%20rentals",
    mapsDest: "https://share.google/aTKF4L5rbS4etRfLd",
  },
   {
    id: "pune-mgroad",
    name: "DOR — Mumbai",
    address: "Coming Soon",
    phoneDisplay: "+918698797007",
    phone: "+918698797007",
    email: "contact@dordressonrent.com",
    instagram: "https://www.instagram.com/dor_designer?igsh=MWp4dmgyMWdibnMxcw==",
    facebook: "https://www.facebook.com/share/1D8F1q6RRZ/?mibextid=wwXIfr",
    whatsapp: "https://wa.me/918698797007?text=Hi%20DOR%20Pune%2C%20I%27d%20like%20to%20rent%20an%20outfit",
    mapsDest: "https://share.google/Nhmiv11PWx4sATzHi",
  },
];


  
  // State for the image slider
  const [currentSlide, setCurrentSlide] = useState(0);
  // State for mobile menu open/close

  // State for Style Advisor feature
  const [eventDescription, setEventDescription] = useState('');
  const [styleAdvice, setStyleAdvice] = useState('');
  const [isLoadingAdvice, setIsLoadingAdvice] = useState(false);
  const [adviceError, setAdviceError] = useState('');

  // --- Firebase Data Fetching for Categories ---
  useEffect(() => {
    const fetchCategories = async () => {
      setLoadingCategories(true);
      setCategoryError('');
      try {
        const menQuery = query(collection(db, 'menCategories'), orderBy('order'));
        const menSnapshot = await getDocs(menQuery);
        const menData = menSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setMenCategories(menData);

        const womenQuery = query(collection(db, 'womenCategories'), orderBy('order'));
        const womenSnapshot = await getDocs(womenQuery);
        const womenData = womenSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setWomenCategories(womenData);

      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategoryError("Failed to load categories. Please try again later.");
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  // --- Firebase Data Fetching for Stores ---
  useEffect(() => {
    const fetchStores = async () => {
      setLoadingStores(true);
      setStoreError('');
      try {
        const storesCollectionRef = collection(db, 'filterOptions', 'stores', 'list');
        const storeSnapshot = await getDocs(storesCollectionRef);
        // Assuming each store document has a 'name' field and potentially an 'image' field
        const fetchedStores = storeSnapshot.docs.map(doc => ({ id: doc.id, name: doc.id,Address: doc.data().Address ||'',mapsDest: doc.data().mapsDest ||'',Addresses: doc.data().Addresses ||'', image: doc.data().imageUrl || `https://placehold.co/1200x600/404040/e0e0e0?text=${doc.id.replace(/\s/g, '+')}` }))   .sort((a, b) => b.name.localeCompare(a.name));
        setStoreLocations(fetchedStores);
        console.log(storeLocations)
      } catch (error) {
        console.error("Error fetching store locations:", error);
        setStoreError("Failed to load store locations. Please try again.");
      } finally {
        setLoadingStores(false);
      }
    };

    fetchStores();
  }, []); // Run once on component mount

  // Auto-slide functionality for store images
  useEffect(() => {
    if (storeLocations.length > 0) { // Only start slider if stores are loaded
      const slideInterval = setInterval(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % storeLocations.length);
      }, 5000);

      return () => clearInterval(slideInterval);
    }
  }, [storeLocations.length]);

  // Function to handle dot clicks for slider
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Function to toggle mobile menu visibility
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Function to get style advice from Gemini API
 

  // --- Scroll Reveal Hooks for each section ---
  const [storesRef, storesIsVisible] = useScrollReveal({ threshold: 0.2 });
  const [sliderRef, sliderIsVisible] = useScrollReveal({ threshold: 0.2 });
  const [menRef, menIsVisible] = useScrollReveal({ threshold: 0.2 });
  const [womenRef, womenIsVisible] = useScrollReveal({ threshold: 0.2 });
  const [howItWorksRef, howItWorksIsVisible] = useScrollReveal({ threshold: 0.3 });
  const [styleAdvisorRef, styleAdvisorIsVisible] = useScrollReveal({ threshold: 0.2 });
  const [aboutUsRef, aboutUsIsVisible] = useScrollReveal({ threshold: 0.2 });
  const [testimonialsRef, testimonialsIsVisible] = useScrollReveal({ threshold: 0.2 });

  return (
    // APPLY THE DYNAMIC THEME CLASS HERE
    <div className={`home-page ${theme === 'light' ? 'light-theme' : 'dark-theme'}`}>
      {/* Store Selection Modal */}
      {/* SEO Optimization with React Helmet */}
      <Helmet>
        <title>DOR Dress On Rent | Dresses &amp; Outfits on Rent</title>
        <meta
          name="description"
          content="Rent stylish dresses and outfits for weddings, parties and special occasions from DOR Dress On Rent. Explore designer outfits available on rent in Pune and Nagpur."
        />
        <link rel="canonical" href="https://www.dordressonrent.com/" />
        
        {/* Preload critical LCP hero images */}
        <link rel="preload" as="image" href="/h211.webp" media="(min-width: 769px)" />
        <link rel="preload" as="image" href="/h1m.webp" media="(max-width: 768px)" />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="DOR Dress On Rent | Dresses &amp; Outfits on Rent" />
        <meta
          property="og:description"
          content="Rent stylish dresses and outfits for weddings, parties and special occasions from DOR Dress On Rent. Explore designer outfits available on rent in Pune and Nagpur."
        />
        <meta property="og:url" content="https://www.dordressonrent.com/" />
        <meta property="og:site_name" content="DOR Dress On Rent" />
        <meta property="og:image" content="https://www.dordressonrent.com/h211.webp" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="DOR Dress On Rent | Dresses &amp; Outfits on Rent" />
        <meta
          name="twitter:description"
          content="Rent stylish dresses and outfits for weddings, parties and special occasions from DOR Dress On Rent. Explore designer outfits available on rent in Pune and Nagpur."
        />
        <meta name="twitter:image" content="https://www.dordressonrent.com/h211.webp" />

        {/* WebSite Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "DOR Dress On Rent",
            "url": "https://www.dordressonrent.com/"
          })}
        </script>

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "DOR Dress On Rent",
            "url": "https://www.dordressonrent.com/",
            "logo": "https://www.dordressonrent.com/logo192.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+918698797007",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": ["en", "hi", "mr"]
            },
            "sameAs": [
              "https://www.instagram.com/dor_designer",
              "https://www.facebook.com/share/1D8F1q6RRZ/?mibextid=wwXIfr"
            ]
          })}
        </script>

        {/* LocalBusiness / ClothingStore Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ClothingStore",
            "name": "DOR Dress On Rent",
            "url": "https://www.dordressonrent.com/",
            "image": "https://www.dordressonrent.com/h211.webp",
            "telephone": "+918698797007",
            "priceRange": "₹₹",
            "department": [
              {
                "@type": "ClothingStore",
                "name": "DOR Dress On Rent - Pune (PCMC)",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Mount Vert Society Square, Hinjawadi - Aundh Rd, next to Yug Honda, Kaspate Wasti",
                  "addressLocality": "Pimpri-Chinchwad",
                  "addressRegion": "Maharashtra",
                  "postalCode": "411057",
                  "addressCountry": "IN"
                },
                "telephone": "+918698797007",
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": [
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday"
                    ],
                    "opens": "10:00",
                    "closes": "21:00"
                  }
                ]
              },
              {
                "@type": "ClothingStore",
                "name": "DOR Dress On Rent - Nagpur",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "BSGN SOCIETY, 7, above ANNA IDLI, Shyam Nagar, Manish Nagar, Somalwada",
                  "addressLocality": "Nagpur",
                  "addressRegion": "Maharashtra",
                  "postalCode": "440037",
                  "addressCountry": "IN"
                },
                "telephone": "+918698797007",
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": [
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday"
                    ],
                    "opens": "10:00",
                    "closes": "21:00"
                  }
                ]
              }
            ],
            "sameAs": [
              "https://www.instagram.com/dor_designer",
              "https://www.facebook.com/share/1D8F1q6RRZ/?mibextid=wwXIfr"
            ]
          })}
        </script>
      </Helmet>
      {showStoreModal && (
        <div className="modal7-overlay">
          <div className="modal7-content">
            <h2 className="modal7-title">Welcome to DOR Dress On Rent!</h2>
            <p className="modal7-description">Please select your preferred store location to start Browse our collections.</p>
            {loadingStores ? (
              <div className="modal7-loading">
                <Loader2 size={32} className="animate-spin text-blue-500" />
                <p className="message-text">Loading stores...</p>
              </div>
            ) : storeError ? (
              <p className="modal7-error">{storeError}</p>
            ) : (
              <div className="modal7-store-options">
                {storeLocations.map((store) => (
                  <button
                    key={store.id}
                    className="btn btn-primary modal7-store-button"
                    onClick={() => {
                      localStorage.setItem('selectedStore', store.name);

window.dispatchEvent(new Event("storeChanged"));

setShowStoreModal(false);
                    }}
                  >
                    
                   <span className="modal7-button-text">
  {store.name}
  {store.Address && ` / ${store.Address}`}
  {store.Addresses && `(${store.Addresses})`}
</span>

                  </button>
                  
                ))}
               
              </div>
            )}
          </div>
        </div>
      )}
      <EarnWithUsModal
          showEarnModal={showEarnModal}
          setShowEarnModal={setShowEarnModal}
          theme={theme}
      />

      {/* Header */}

      <Header
  theme={theme}
  toggleTheme={toggleTheme}
  scrolled={scrolled}
  isMobileMenuOpen={isMobileMenuOpen}
  toggleMobileMenu={toggleMobileMenu}
  setShowEarnModal={setShowEarnModal}
/>
{/* LEFT STICKY SOCIAL BAR */}
<div className="left-social-bar">
  <a href="https://www.instagram.com/dor_designer?igsh=MWp4dmgyMWdibnMxcw==" target="_blank">
    <Instagram size={22} className="icon-instagram" />
  </a>
  <a href="https://www.facebook.com/share/1D8F1q6RRZ/?mibextid=wwXIfr" target="_blank">
    <Facebook size={22} className="icon-facebook" />
  </a>
  <a href="https://wa.me/918698797007?text=Hi%20DOR%20%2C%20need%20help%20with%20rentals" target="_blank">
    <WhatsAppIcon size={22} className="icon-whatsapp" />
  </a>
</div>



      {/* Hero Section */}
      {/* Hero Section - Alternative Design */}
      {/* Hero Section - Split Layout Design */}
      {/* Hero Section - Ultimate Design with Background Image */}
      <HeroSlider/>
      {/* Store Locations Section */}
      {/* Store Locations Section */}
<section id="stores-location"
  ref={storesRef}
  // Removed 'bg-white' to inherit the theme's soft off-white background (var(--color-dark))
  className={`section collab-collection ${storesIsVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
  <div className="container text-center">
    {/* H2 tag is already well-placed for section title */}
    <h2 className="section-title">DOR Dress On Rent Stores</h2>
    <p style={{ maxWidth: "800px", margin: "0 auto 2rem", color: "var(--color-dark)", opacity: 0.8, lineHeight: 1.6 }}>
      Visit our DOR Dress On Rent stores in Pune and Nagpur. Try our stunning designer outfits for free and rent them easily for your special dates.
    </p>
    {loadingStores ? (
      <div className="message-container loading">
        <Loader2 size={48} className="animate-spin text-blue-500" />
        <p className="message-text">Loading our dress rental stores...</p>
      </div>
    ) : storeError ? (
      <p className="message-container error">{storeError}</p>
    ) : storeLocations.length === 0 ? (
      <p className="message-container no-products">No store locations found.</p>
    ) : (
    <div className="grid-3-col">
  {storeLocations.map((store) => (
    <div
      key={store.id}
      className="store-card"
      onClick={() => window.open(store.mapsDest, "_blank")}
      style={{ cursor: "pointer" }}
    >
      <img
        src={store.image || ""}
        alt={`DOR Dress On Rent store location in ${store.name}`}
        className="store-card-image"
        loading="lazy"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = `https://placehold.co/400x300/cccccc/333333?text=DOR ${store.name} Store`;
        }}
      />

      <h3 className="card-title">
        {store.name}
        {store.Address && ` / ${store.Address}`} Store
        {store.Addresses && ` (${store.Addresses})`}
      </h3>
    </div>
  ))}
</div>
    )}
  </div>
</section>

      {/* Store Image Slider */}
      
      {/* Women's Collection Section */}
      <section id="women" ref={womenRef} className={`section bg-neutral-100 collab-collection ${womenIsVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
        <div className="container">
          {/* H2 tag is appropriate for the section title */}
          <h2 className="section-title">Women's Designer Collection on Rent</h2>
          <p style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto 2.5rem", color: "var(--color-dark)", opacity: 0.8, lineHeight: 1.6 }}>
            Explore our premium collection of women's ethnic and party wear available for rent. From elegant Lehengas to designer Gowns, find your perfect outfit for any occasion.
          </p>

          {loadingCategories ? (
            <p className="text-center text-gray-600">Loading women's rental categories...</p>
          ) : categoryError ? (
            <p className="text-center text-red-500">{categoryError}</p>
          ) : (
            <div className={`grid-4-col stagger-grid ${womenIsVisible ? 'is-visible' : ''}`}>
  {womenCategories.map((category) => (
    <Link
      to={`/collection/women/${category.name}`}
      key={category.id}
      className="category-card alt-card reveal-item"
      aria-label={`Explore Women's ${category.name} collection for rent`}
    >
      <img
        src={category.imageUrl || category.image}
        alt={`DOR Women's ${category.name} on Rent`}
        className="category-card-image"
        loading="lazy"
        onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/400x300/cccccc/333333?text=Women's ${category.name}`; }}
      />
      <div className="category-card-content">
        <h3 className="card-title">{category.name}</h3>
        <p className="card-subtitle">Discover More</p>
      </div>
    </Link>
  ))}
</div>

          )}
        </div>
      </section>
      {/* Men's Collection Section */}

      <section id="men" ref={menRef} className={`section bg-white collab-collection  ${menIsVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
  <div className="container">
    <h2 className="section-title">Men's Premium Collection on Rent</h2>
    <p style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto 2.5rem", color: "var(--color-dark)", opacity: 0.8, lineHeight: 1.6 }}>
      Discover stylish men's wear on rent, including classic Sherwanis, trendy Indo-Western suits, and sophisticated Tuxedos, tailored to make a statement.
    </p>

    {loadingCategories ? (
      <p className="text-center text-gray-600">Loading men's rental categories...</p>
    ) : categoryError ? (
      <p className="text-center text-red-500">{categoryError}</p>
    ) : (
      /* ⬇️ add stagger-grid + visibility toggle */
      <div className={`grid-4-col stagger-grid ${menIsVisible ? 'is-visible' : ''}`}>
        {menCategories.map((category) => (
          <Link
            to={`/collection/men/${category.name}`}
            key={category.id}
            /* ⬇️ mark each card as a reveal-item */
            className="category-card reveal-item"
            aria-label={`Explore Men's ${category.name} collection for rent`}
          >
            <img
              src={category.imageUrl || category.image}
              alt={`DOR Men's ${category.name} on Rent`}
              className="category-card-image"
              loading="lazy"
              onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/400x300/cccccc/333333?text=Men's ${category.name}`; }}
            />
            <div className="category-card-content">
              <h3 className="card-title">{category.name}</h3>
              <p className="card-subtitle">Explore Styles</p>
            </div>
          </Link>
        ))}
      </div>
    )}
  </div>
</section>

<section
  id="how-it-works"
  ref={howItWorksRef}
  className={`section bg-white ${
    howItWorksIsVisible ? "animate-fade-in-up" : "opacity-0 translate-y-8"
  }`}
  style={{ transitionDelay: "0.1s" }}
>
  <div className="container text-center">
    <h2 className="section-title">✨ How It Works ✨</h2>

    <div className="grid-3-col">
      
      {/* Step 1 */}
      <div
        className={`how-it-works-step-card ${
          howItWorksIsVisible ? "animate-fade-in-up" : "opacity-0 translate-y-8"
        }`}
        style={{ transitionDelay: "0.1s" }}
      >
        <div className="how-it-works-icon-wrapper">
          <Sparkles size={36} className="how-it-works-icon" />
        </div>

        <h3 className="card-title">1. RENT 👗</h3>

        <p className="step-description">
          👗 Visit our store & explore stunning outfits <br />
          💃 Try as much as you want — FREE unlimited trials! <br />
          📅 Book your favorite dress for your special dates <br />
          ⏳ Minimum rental: 3 days
        </p>
      </div>

      {/* Step 2 */}
      <div
        className={`how-it-works-step-card ${
          howItWorksIsVisible ? "animate-fade-in-up" : "opacity-0 translate-y-8"
        }`}
        style={{ transitionDelay: "0.2s" }}
      >
        <div className="how-it-works-icon-wrapper">
          <Shirt size={36} className="how-it-works-icon" />
        </div>

        <h3 className="card-title">2. SLAY 🔥</h3>

        <p className="step-description">
          📍 Day 1 – Pick up your outfit <br />
          🔥 Day 2 – Wear it & steal the spotlight <br />
          🔄 Day 3 – Return it, hassle-free <br />
          ➕ Need more time? Customize your rental days at an extra cost
        </p>
      </div>

      {/* Step 3 */}
      <div
        className={`how-it-works-step-card ${
          howItWorksIsVisible ? "animate-fade-in-up" : "opacity-0 translate-y-8"
        }`}
        style={{ transitionDelay: "0.3s" }}
      >
        <div className="how-it-works-icon-wrapper">
          <Crown size={36} className="how-it-works-icon" />
        </div>

        <h3 className="card-title">3. RETURN 🧼</h3>

        <p className="step-description">
          🧼 We’ve got you covered! <br />
          ✔ Before pickup: Professionally dry-cleaned, sanitized & perfectly altered for you <br />
          ✔ After use: No stress — we handle the dry cleaning <br />
          💖 Zero maintenance. Maximum glam.
        </p>
      </div>

    </div>
  </div>
</section>


      


      {/* How It Works Section */}
   

       <CollaborationSection />

      {/* ✨ Style Advisor Section (Gemini API Integration) ✨ */}
         {/* uploader */}
      

      {/* live list */}
      {/* <CustomerReviewsSection /> */}
      {/* <CustomerReviewUpload onSubmitted={() => console.log("uploaded")} /> */}
      <ReviewsSection />
      
      



      {/* Footer */}
      <footer id="contact" className="footer">
      <div className="footer-container">
        {stores.map((s) => (
          <div className="footer-col" key={s.id}>
            <h3 className="footer-heading">{s.name}</h3>
            <ul className="footer-list">
              <li className="contact-item align-start">
                <MapPin size={18} className="icon-mr" />
                <address className="address-text">{s.address}</address>
              </li>
              <li className="contact-item">
                <Phone size={18} className="icon-mr" />
                <a href={`tel:${s.phone}`} className="footer-link">{s.phoneDisplay}</a>
              </li>
              <li className="contact-item">
                <Mail size={18} className="icon-mr" />
                <a href={`mailto:${s.email}`} className="footer-link">{s.email}</a>
              </li>
            </ul>

            <div className="social-links" style={{ marginTop: ".75rem" }}>
              <a
                href={s.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon animate-social-pop"
                aria-label={`${s.name} on Instagram`}
                title="Instagram"
              >
                <Instagram size={22} className="icon-instagram" />
              </a>

              <a
                href={s.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon animate-social-pop"
                aria-label={`${s.name} on Facebook`}
                title="Facebook"
              >
                <Facebook size={22} className="icon-facebook" />
              </a>

              <a
                href={s.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon animate-social-pop"
                aria-label={`WhatsApp ${s.name}`}
                title="WhatsApp"
              >
                <FaWhatsapp size={22} className="icon-whatsapp" />
              </a>

              <a
                href={`${s.mapsDest}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon animate-social-pop"
                aria-label={`Directions to ${s.name}`}
                title="Get Directions"
              >
                <Navigation size={22} />
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="footer-links-row" style={{ display: "flex", justifyContent: "center", gap: "1.5rem", flexWrap: "wrap", marginTop: "2rem", marginBottom: "1rem" }}>
        <Link to="/blog" className="footer-link">Blog</Link>
        <Link to="/partner" className="footer-link">Franchise</Link>
        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        <Link to="/terms" className="footer-link">Terms & Conditions</Link>
      </div>

      <div className="copyright">
        &copy; {new Date().getFullYear()} DOR. All rights reserved.
      </div>
    </footer>
    </div>
  );
}

export default HomePage;